module.exports = __webpack_public_path__ + "img/UserLOGO.c1e1b848.svg";